import React from 'react';
import { modules, type ModuleColor } from '../data/content';
const headerBg: Record<ModuleColor, string> = {
  navy: 'bg-module-navy',
  green: 'bg-module-green',
  teal: 'bg-module-teal',
  purple: 'bg-module-purple',
  red: 'bg-module-red',
  charcoal: 'bg-module-charcoal'
};
export function Modules() {
  return <section className="bg-clinical px-3 py-4 sm:px-6" data-id="element-101" data-mp="20v3vj2ahxy5q">
      <div className="mx-auto max-w-2xl" data-id="element-102" data-mp="145w8fpu8bgzp">
        <h2 className="text-center text-[1.2rem] font-extrabold uppercase text-navy sm:text-[1.8rem]" data-id="element-103" data-mp="1477l6f5njz2y">
          What's included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-104" data-mp="189axf605b7pa">
          {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-navy/10 bg-white shadow-sm" data-id="element-105" data-mp="1d59fycyslvhs">
              <div className={`flex items-center gap-1.5 px-2.5 py-1.5 ${headerBg[mod.color]}`} data-id="element-106" data-mp="2omixgtyd2dgg">
                <span className="text-[0.8rem] leading-none" aria-hidden="true" data-id="element-107" data-mp="2tk19it7od8so">
                  ✅
                </span>
                <h3 className="text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-white sm:text-[0.88rem]" data-id="element-108" data-mp="1trr7e0oyc9f">
                  Module {mod.number} — {mod.title}
                </h3>
              </div>
              <div className="px-2.5 py-2" data-id="element-109" data-mp="3p1vjb1hhbg04">
                <p className="text-[0.78rem] leading-[1.35] sm:text-[0.92rem]" data-id="element-110" data-mp="3k17jbqb9votr">{mod.body}</p>
                <p className="mt-1 font-heading text-[0.68rem] font-extrabold uppercase tracking-wide text-teal sm:text-[0.8rem]" data-id="element-111" data-mp="3f24nmwh6muyg">
                  {mod.steps}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}